import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./en/resource";
import translationAR from "./ar/resource";

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      // Check localStorage first, then navigator as fallback
      order: ["localStorage", "navigator"],

      // Use your custom localStorage key
      lookupLocalStorage: "lang",

      // Cache the detected language back to localStorage
      caches: ["localStorage"],

      excludeCacheFor: ["cimode"],

      // Convert detected language codes to supported ones
      convertDetectedLanguage: (lng: string) => {
        // Normalize to lowercase and extract base language code
        const baseLang = lng.toLowerCase().split("-")[0];

        // Map to supported languages
        if (baseLang === "ar") {
          return "ar";
        }
        if (baseLang === "en") {
          return "en";
        }

        // Default to English for unsupported languages
        return "en";
      },
    },
    resources,
    fallbackLng: ["en", "ar"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
